import { render, staticRenderFns } from "./BatchReportView.vue?vue&type=template&id=565e755c&scoped=true"
import script from "./BatchReportView.vue?vue&type=script&lang=js"
export * from "./BatchReportView.vue?vue&type=script&lang=js"
import style0 from "./BatchReportView.vue?vue&type=style&index=0&id=565e755c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565e755c",
  null
  
)

export default component.exports